// library imports
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Conversations } from "@ant-design/x";
import { Button, Flex, Input, Pagination, Space } from "antd";
import { useEffect, useMemo, useState } from "react";
// function imports
import useEditConversation from "../../functions/Conversation/editConversation";
import useRemoveConversation from "../../functions/Conversation/removeConversation";

export default function ChatConversation({
  activeConversation,
  conversationList,
  handleRefreshConversation,
  handleChangeConversation,
}) {
  const [conversationItems, setConversationItems] = useState([]);
  const [editKey, setEditKey] = useState(null);
  const [searchValue, setSearchValue] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const { editConversation, editLoading } = useEditConversation();
  const { removeConversation } = useRemoveConversation();

  const CONVERSATION_MENU = (conversation) => ({
    items: [
      {
        label: "Edit Conversation",
        key: "edit",
        icon: <EditOutlined />,
        onClick: () => {
          setEditKey(conversation.key);
        },
      },
      {
        label: "Delete Conversation",
        key: "delete",
        icon: <DeleteOutlined />,
        danger: true,
        onClick: () => {
          removeConversation(conversation.key, handleDeleteSuccess);
        },
      },
    ],
  });

  // For handle only show limit items base on page and page size
  const paginatedItems = useMemo(() => {
    let pageCount = currentPage;
    let startIndex = (pageCount - 1) * pageSize;
    return conversationItems.slice(startIndex, startIndex + pageSize);
  }, [pageSize, currentPage, conversationItems]);

  // For handle pagination page change
  function handlePageChange(page, pageSize) {
    setCurrentPage(page);
    setPageSize(pageSize);
  }

  function handleAdd() {
    handleChangeConversation(null);
  }

  function handleEditSuccess() {
    handleRefreshConversation(editKey);
    setEditKey(null);
  }

  function handleDeleteSuccess(key) {
    if (activeConversation == key) {
      handleRefreshConversation(null);
    } else {
      handleRefreshConversation(activeConversation);
    }
  }

  function handleSearch() {
    let filterList = conversationList.filter((value) => {
      if (searchValue != null) {
        return String(value["label"]).includes(String(searchValue));
      } else {
        return value;
      }
    });

    setConversationItems(filterList);
  }

  useEffect(() => {
    setConversationItems(conversationList);
  }, [conversationList]);

  useEffect(() => {
    let updateItems = conversationItems.map((prev) =>
      prev.key == editKey
        ? {
            ...prev,
            label: (
              <Space.Compact>
                <Input
                  defaultValue={prev.label}
                  onPressEnter={(e) => {
                    editConversation(
                      e.target.value,
                      prev.key,
                      handleEditSuccess,
                    );
                  }}
                />
              </Space.Compact>
            ),
          }
        : prev,
    );
    setConversationItems(updateItems);
  }, [editKey]);

  return (
    <Flex vertical="vertical" style={{ height: "80%" }} gap={"small"}>
      <Flex vertical="vertical" gap={"middle"} align="center">
        <Input.Search
          placeholder="Seach Conversation"
          onSearch={handleSearch}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          allowClear={true}
          style={{ width: "90%" }}
        />
        <Button
          icon={<PlusOutlined />}
          children={"Add New Conversation"}
          type="primary"
          onClick={handleAdd}
          style={{ width: "90%" }}
        />
        <Flex justify="center">
          <Pagination
            size="small"
            onChange={handlePageChange}
            pageSize={pageSize}
            current={currentPage}
            total={conversationItems.length}
            showSizeChanger={false}
            responsive
          />
        </Flex>
        <Conversations
          items={paginatedItems}
          menu={CONVERSATION_MENU}
          activeKey={activeConversation}
          onActiveChange={(value) => {
            handleChangeConversation(value);
          }}
          style={{ width: "100%" }}
        />
      </Flex>
    </Flex>
  );
}
